import React, { Component } from 'react';

import LevelReport from '../Widgets/LevelReport';
import AdsMetrics from '../Widgets/AdsMetrics';
import GeneralVision from '../Widgets/GeneralVision';
import CampaignRange from '../Widgets/CampaignRange';
import GenderOrAgesPerformance from '../Widgets/GenderOrAgesPerformance';
import DevicePerformance from '../Widgets/DevicePerformance';
import Keywords from '../Widgets/Keywords';
import AdsGroups from '../Widgets/AdsGroups';

import SimpleLineChart from '../Widgets/charts/SimpleLineChart';
import SimpleBarChart from '../Widgets/charts/SimpleBarChart';
import PieChartWithCustomizedLabel from '../Widgets/charts/PieChartWithCustomizedLabel';
import Cards from '../Widgets/charts/Cards';
import BiaxialBarChart from '../Widgets/charts/BiaxialBarChart';

import TableDefault from '../Widgets/tables';

import Ads from '../Widgets/Ads';

export default class DynamicComponent extends Component {
	components = {
		LevelReport,
		AdsMetrics,
		GeneralVision,
		CampaignRange,
		GenderOrAgesPerformance,
		DevicePerformance,
		AdsGroups,
		Keywords,
		SimpleLineChart,
		SimpleBarChart,
		PieChartWithCustomizedLabel,
		Cards,
		BiaxialBarChart,
		Ads,
		TableDefault,
	};

	checkTag = tag => Object.keys(this.components).map((component) => {
		if (component === tag) {
			return tag;
		}

		return false;
	});

	render() {
		const {
			tag, data, captions, typeChart, alias, channel, title, keys, isLast,
		} = this.props;

		const TagName = this.checkTag(tag) ? this.components[tag] : '';

		return TagName
			? (
				<TagName
					data={data}
					captions={captions}
					typeChart={typeChart}
					alias={alias}
					channel={channel}
					title={title}
					keys={keys}
					isLast={isLast}
				/>
			)
			: null;
	}
}
